// extracted by mini-css-extract-plugin
export default {"title":"AddClientAllocation_title__RY9Ij"};